import React from 'react';

const PersonIcon = (props) => {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5 20.5121C18.69 15.0271 15.3537 12.4834 12.045 12.4834C8.73625 12.4834 5.31125 15.0259 4.5 20.5109" stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="7.9834" r="4.5" stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}



export default PersonIcon;